var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8234 3.01465H2.27737C1.84804 3.01465 1.5 3.36269 1.5 3.79201V20.3556C1.5 20.7849 1.84804 21.133 2.27737 21.133H21.8234C22.2528 21.133 22.6008 20.7849 22.6008 20.3556V3.79201C22.6008 3.36269 22.2528 3.01465 21.8234 3.01465Z",
    stroke: "#2A5A16",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62659 9.28809H5.32766C4.89833 9.28809 4.55029 9.63612 4.55029 10.0655V12.3644C4.55029 12.7937 4.89833 13.1417 5.32766 13.1417H7.62659C8.05591 13.1417 8.40395 12.7937 8.40395 12.3644V10.0655C8.40395 9.63612 8.05591 9.28809 7.62659 9.28809Z",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1998 9.28809H10.9009C10.4716 9.28809 10.1235 9.63612 10.1235 10.0655V12.3644C10.1235 12.7937 10.4716 13.1417 10.9009 13.1417H13.1998C13.6292 13.1417 13.9772 12.7937 13.9772 12.3644V10.0655C13.9772 9.63612 13.6292 9.28809 13.1998 9.28809Z",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7731 9.28809H16.4741C16.0448 9.28809 15.6968 9.63612 15.6968 10.0655V12.3644C15.6968 12.7937 16.0448 13.1417 16.4741 13.1417H18.7731C19.2024 13.1417 19.5504 12.7937 19.5504 12.3644V10.0655C19.5504 9.63612 19.2024 9.28809 18.7731 9.28809Z",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62659 14.5889H5.32766C4.89833 14.5889 4.55029 14.9369 4.55029 15.3662V17.6652C4.55029 18.0945 4.89833 18.4425 5.32766 18.4425H7.62659C8.05591 18.4425 8.40395 18.0945 8.40395 17.6652V15.3662C8.40395 14.9369 8.05591 14.5889 7.62659 14.5889Z",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1998 14.5889H10.9009C10.4716 14.5889 10.1235 14.9369 10.1235 15.3662V17.6652C10.1235 18.0945 10.4716 18.4425 10.9009 18.4425H13.1998C13.6292 18.4425 13.9772 18.0945 13.9772 17.6652V15.3662C13.9772 14.9369 13.6292 14.5889 13.1998 14.5889Z",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7731 14.5889H16.4741C16.0448 14.5889 15.6968 14.9369 15.6968 15.3662V17.6652C15.6968 18.0945 16.0448 18.4425 16.4741 18.4425H18.7731C19.2024 18.4425 19.5504 18.0945 19.5504 17.6652V15.3662C19.5504 14.9369 19.2024 14.5889 18.7731 14.5889Z",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.34766H22.6008",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27187 1H6.69973C6.2704 1 5.92236 1.34804 5.92236 1.77737V5.02675C5.92236 5.45608 6.2704 5.80412 6.69973 5.80412H7.27187C7.7012 5.80412 8.04924 5.45608 8.04924 5.02675V1.77737C8.04924 1.34804 7.7012 1 7.27187 1Z",
    fill: "#EBFFB3",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4013 1H16.8291C16.3998 1 16.0518 1.34804 16.0518 1.77737V5.02675C16.0518 5.45608 16.3998 5.80412 16.8291 5.80412H17.4013C17.8306 5.80412 18.1786 5.45608 18.1786 5.02675V1.77737C18.1786 1.34804 17.8306 1 17.4013 1Z",
    fill: "#EBFFB3",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0567 25.0001C22.7903 25.0001 25.0064 22.784 25.0064 20.0503C25.0064 17.3167 22.7903 15.1006 20.0567 15.1006C17.323 15.1006 15.1069 17.3167 15.1069 20.0503C15.1069 22.784 17.323 25.0001 20.0567 25.0001Z",
    fill: "#EBFFB3",
    stroke: "#2A5A16",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0322 16.9316V20.0193C20.8884 19.6783 21.7445 19.3373 22.6006 18.9963",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.1baff093f1a29f896f6692fe96f6276f.svg";
export { ForwardRef as ReactComponent };